"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarknetContractParamsProvider = void 0;
const redstone_sdk_1 = require("redstone-sdk");
class StarknetContractParamsProvider extends redstone_sdk_1.ContractParamsProvider {
    async requestPayload(requestParams) {
        let requestParamsChanged = { ...requestParams };
        requestParamsChanged["dataFeeds"] = undefined;
        return await super.requestPayload(requestParamsChanged);
    }
}
exports.StarknetContractParamsProvider = StarknetContractParamsProvider;
//# sourceMappingURL=StarknetContractParamsProvider.js.map